module.exports = __webpack_public_path__ + "img/step6.e923c9ec.png";